import Swiper, {Navigation, Pagination, Thumbs} from 'swiper/core';

Swiper.use([Navigation, Pagination, Thumbs]);

// init Swiper:

function initSingleSwiper() {

    let singleSwiper = new Swiper('.is-single-swiper', {
        // Navigation arrows
        navigation: {
            nextEl: '.js-swiper-button-next',
            prevEl: '.js-swiper-button-prev',
        },
        freeMode: false,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        threshold: 30,
        autoHeight: true,
        pagination: {
            el: '.is-swiper-pagination',
            clickable: true
        },
        on: {
            beforeSlideChangeStart: function (e) {
                //console.log('beforeSlideChangeStart');
            },
            activeIndexChange:  (e) => {
                let el = $(e.$el[0].children[0].children[(e.activeIndex)]);
                $('.zoomContainer').remove();
                $(e.slides).find('img').removeClass('zoom_image_extra');
                el.find('img').addClass('zoom_image_extra');
                initExtraImageZoom($(e.slides[e.activeIndex]).find('.zoom_image_extra'));
            }
        },
    });

}

function initExtraImageZoom(el) {

    el.ezPlus({
        zoomType: 'inner',
        lensSize: 230,
        responsive: true,
        borderColour: '#cccccc',
        borderSize: 1
    });
}

let callapseItems = $('.is-accordion-data').find('.accordion-collapse');

callapseItems.on('shown.bs.collapse', function (e) {
    let el = $(e.currentTarget).find('.zoom_image_extra');
    initExtraImageZoom(el);
})

callapseItems.on('hidden.bs.collapse', function (e) {
    $('.zoomContainer').remove();
})



initSingleSwiper();

